import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  onErrorHandler,
  ErrorBoundaryFallbackComponent,
  withErrorBoundary
} from 'components/ErrorBoundry/ErrorBoundry';

const ExpandButton = styled.span`
  display: block;
  cursor: pointer;
  font-family: $font-family-lato;
  font-size: 12px;
  text-transform: uppercase;
  color: #04844B;
  margin-top: 4px;
`;

@withTranslation(['common'])
class ExpandText extends Component {
  constructor(props) {
    super(props);

    this.clickHandler = this.clickHandler.bind(this);

    this.state = {
      showFull: false
    };
  }

  clickHandler(e) {
    const { showFull } = this.state;
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      showFull: !showFull
    });
  }

  render() {
    const {
      text,
      maxLength,
      className,
      showReadMore,
      t
    } = this.props;
    const { showFull } = this.state;

    let visibleText = null;
    const _text = isEmpty(text) ? '' : text;

    if (_text.length <= maxLength) {
      visibleText = <span>{ _text }</span>;
    }
    if (showFull && _text.length > maxLength) {
      visibleText = (
        <span>
          { `${_text} ` }
          <ExpandButton onClick={this.clickHandler} onKeyDown={this.clickHandler}>
            Less
          </ExpandButton>
        </span>
      );
    } else if (!showFull && _text.length > maxLength) {
      const firstHalf = _text.substring(0, maxLength);

      visibleText = (
        <span>
          { `${firstHalf}... ` }
          {
            showReadMore
              ? (
                <ExpandButton onClick={this.clickHandler} onKeyDown={this.clickHandler}>
                  {t('READ_MORE')}
                </ExpandButton>
              )
              : null
          }
        </span>
      );
    }

    return <span className={className}>{visibleText}</span>;
  }
}

ExpandText.propTypes = {
  text: PropTypes.string.isRequired,
  maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
  showReadMore: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

ExpandText.defaultProps = {
  className: '',
  showReadMore: true,
};

export default withErrorBoundary(
  ExpandText,
  ErrorBoundaryFallbackComponent,
  onErrorHandler,
);
